module.exports = __webpack_public_path__ + "img/led_summary_Image.7754ad72.png";